// extracted by mini-css-extract-plugin
export default {"address":"F99rztgtR-RU4LmTmBSkVQ==","content":"zr4YyqxGdIS9P+SfUGrWUg=="};